import { Link } from "react-router-dom";
import logo from "../../assets/pvm-logo.png";
import { CONTACT_INFO, NAV_LINKS, SERVICE_CONTENT } from "../utils/constants";
import { IconPhone, IconMail, IconMapPin } from "../utils/icons";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-grid">
                <div className="footer-brand">
                    <img className="logo-img footer-logo" src={logo} alt={CONTACT_INFO.businessName} />
                    <p>
                        Personal, full-service financial guidance for working
                        professionals — investments, insurance, tax and more,
                        managed by one person you can trust.
                    </p>
                </div>

                <div className="footer-links">
                    <h4>Quick Links</h4>
                    <ul>
                        {NAV_LINKS.map((link) => (
                            <li key={link.path}>
                                <Link to={link.path}>{link.label}</Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="footer-links">
                    <h4>Services</h4>
                    <ul>
                        {SERVICE_CONTENT.map((service) => (
                            <li key={service.title}>{service.title}</li>
                        ))}
                    </ul>
                </div>

                <div className="footer-contact">
                    <h4>Contact</h4>
                    <p><IconPhone /> {CONTACT_INFO.phoneDisplay}</p>
                    <p><IconMail /> {CONTACT_INFO.email}</p>
                    <p>
                        <IconMapPin />
                        <span>
                            {CONTACT_INFO.addressLines.map((line) => (
                                <span key={line} className="address-line">{line}</span>
                            ))}
                        </span>
                    </p>
                </div>
            </div>

            <div className="footer-bottom">
                &copy; {new Date().getFullYear()} {CONTACT_INFO.businessName}. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
